export default __webpack_public_path__ + "static/media/discord.963e2858.svg";